module.exports = __webpack_public_path__ + "img/battery-replacement.226f19bc.png";